$(document).ready(function() {
    const sendOrderConfirmationInput = $('input[name="send_order_confirmation"]').parent();
    const deliveryEmailInput = $('input[name="delivery_email"]');

    if (sendOrderConfirmationInput.length) {
        showOrderConfirmationCheckbox();
        deliveryEmailInput.on('keyup', _.debounce(showOrderConfirmationCheckbox, 500));

        function showOrderConfirmationCheckbox() {
            if (deliveryEmailInput.val().length > 0) {
                sendOrderConfirmationInput.show();
            } else {
                sendOrderConfirmationInput.hide();
            }
        }
    }

    $(document).ready(function() {
        $('.prototype-container #sortable.order-products').children('.row.main-row').each(function () {
            let sellingPrice = $(this).find('input[data-function="price-total-handler"]');
            let purchasePrice = $(this).find('input[data-function="price-handler"]');
            let discount = $(this).find('input[data-function="discount-handler"]');
            let priceMargin = $(this).find('.price-margin');

            const triggerMarginCalculation = () => {
                let sellingPriceValue = parseFloat(sellingPrice.val());
                let purchasePriceValue = parseFloat(purchasePrice.val());
                if (!isNaN(sellingPriceValue) && !isNaN(purchasePriceValue)) {
                    let margin = sellingPriceValue - purchasePriceValue;
                    priceMargin.text(margin.toFixed(2));
                }
            };

            triggerMarginCalculation();

            const debouncedMarginCalculation = _.debounce(triggerMarginCalculation, 500);

            sellingPrice.on('keyup', debouncedMarginCalculation);
            discount.on('keyup', debouncedMarginCalculation);
            purchasePrice.on('keyup', debouncedMarginCalculation);
        });
    });

});
